var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('background-img',[_c('v-btn',{attrs:{"to":"/player","text":""}},[_c('span',{staticClass:"mr-2 white--text"},[_vm._v("Player List")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }